import { List, Modal, Space } from 'antd'
import React, { useState } from 'react'
import {BookOutlined} from '@ant-design/icons';
function SoftCourseDesc(props) {
    const [open,setOpen] = useState(false)    
    return (
        <>
            <List.Item 
                key={props.bjcks_id}
                style={{lineHeight:"40px"}}
            >
                <a onClick={() => {setOpen(true)}}>
                    <Space>
                        <BookOutlined /> {props.bjcks_name}
                    </Space>
                </a>
            </List.Item>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                onCancel={() => {
                    setOpen(false);
                }}
                onOk={() => {}}
                footer={null}
                width={1200}
                title={props.bjcks_name}
            >            
                <div dangerouslySetInnerHTML={{__html:props.bjcks_content}}></div>               
            </Modal>
        </>
    )
}

export default SoftCourseDesc